import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Bullseye, Flex, FlexItem, Grid, GridItem } from '@patternfly/react-core';
import React, { useEffect } from 'react';
import { faChevronDown, faChevronUp, faCopy, faTrash } from '@fortawesome/pro-light-svg-icons';
import { PresentationSlide } from '../../api/present/PresentationSlide';
import { useCommonStoreContext } from '../../components/common-store/CommonStoreProvider';

interface Props {
	displayOnly?: boolean;
	slides: PresentationSlide[];
	selectedPage: number;
	addNewPage: () => void;
	removePage: (index: number) => void;
	duplicatePage?: (index: number) => void;
	movePageUp?: (index: number) => void;
	movePageDown?: (index: number) => void;
	updateSelectedPage: (slideNumber: number) => void;
	isView?: boolean;
}

const PresentationPageList = (props: Props) => {
	const {
		slides,
		addNewPage,
		removePage,
		duplicatePage,
		movePageUp,
		movePageDown,
		selectedPage,
		updateSelectedPage,
		isView,
	} = props;
	const { setCurrentSelectedPresentSlide } = useCommonStoreContext();

	useEffect(() => {
		setCurrentSelectedPresentSlide(selectedPage);
	}, [selectedPage]);

	return (
		<Grid span={12}>
			{slides
				.sort((a, b) => (a.page > b.page ? 1 : b.page > a.page ? -1 : 0))
				.map((slide, index) => {
					return (
						<GridItem span={10}>
							<Flex
								align={{ default: 'alignRight' }}
								justifyContent={{ default: 'justifyContentFlexEnd' }}
								className={`presentation-page-preview ${
									selectedPage === index ? 'selected' : ''
								}`}
								onClick={() => updateSelectedPage(index)}
							>
								<FlexItem style={{ position: 'absolute', marginRight: 0 }}>
									{!props.isView && (
										<>
											<FontAwesomeIcon
												icon={faTrash}
												className="delete-icon"
												onClick={(e) => {
													e.stopPropagation();
													removePage && removePage(index);
												}}
											/>
											<FontAwesomeIcon
												icon={faCopy}
												className="duplicate-icon"
												onClick={(e) => {
													e.stopPropagation();
													duplicatePage && duplicatePage(index);
												}}
											/>
											{index > 0 ? (
												<FontAwesomeIcon
													icon={faChevronUp}
													className="move-up-icon"
													onClick={(e) => {
														e.stopPropagation();
														movePageUp && movePageUp(index);
													}}
												/>
											) : (
												<div style={{ height: 23 }}></div>
											)}
											{index + 1 != slides.length && (
												<FontAwesomeIcon
													icon={faChevronDown}
													className="move-down-icon"
													onClick={(e) => {
														e.stopPropagation();
														movePageDown && movePageDown(index);
													}}
												/>
											)}
										</>
									)}
								</FlexItem>
								<Bullseye style={{ fontSize: '3rem', width: '100%' }}>
									{index + 1}
								</Bullseye>
							</Flex>
						</GridItem>
					);
				})}
			{!isView && (
				<GridItem span={10}>
					<Flex
						className="presentation-page-preview new"
						alignItems={{ default: 'alignItemsCenter' }}
						justifyContent={{ default: 'justifyContentCenter' }}
						onClick={() => addNewPage()}
					>
						<FontAwesomeIcon
							icon={faPlus}
							size="xl"
						/>
					</Flex>
				</GridItem>
			)}
		</Grid>
	);
};

export default PresentationPageList;
